import React from 'react';


export class TextArea extends React.Component {
    render() {
        return (
            <div className={"textArea"}>
                <div className={"inputLabel"}>
                    <p>
                        { this.props.label }
                    </p>
                </div>
                <textarea
                    placeholder={this.props.placeholder}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    name={ this.props.name }
                    maxLength={this.props.maxLength}
                />
            </div>
        );
    }
}